<div class="container-fluid mb-5">
  <div class="row">
    <div class="col-12 mt-2">
      <form autocomplete="off" [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <div class="card mb-3 bg-2">
              <div class="card-body">
                <div class="row">
                  <div class=" col-md-2 timestamp">
                    <lib-datepicker-day [schema]="dataSchema"></lib-datepicker-day>
                  </div>
                  <div class=" col-md-3 username">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Usuário</mat-label>
                      <input matInput type="text" formControlName="username">
                    </mat-form-field>
                  </div>
                  <div class=" col-md-2 action">
                    <mat-form-field class="w-100" appearance="outline">
                      <mat-label>Ação</mat-label>
                      <mat-select formControlName="action">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let s of acao" [value]="s.id">
                          {{ s.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class=" col-md-2 entryType">
                    <mat-form-field class="w-100" appearance="outline">
                      <mat-label>Tipo</mat-label>
                      <mat-select formControlName="entryType">
                        <mat-option value=""></mat-option>
                        <mat-option *ngFor="let Ti of tipos" [value]="Ti.name">
                          {{ Ti.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class=" col-md-3 description">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Descrição</mat-label>
                      <input matInput type="text" formControlName="description">
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="card-footer clearfix">
                <div class="d-flex flex-row justify-content-end">
                  <div class="pr-3">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="page$.next(1)"
                      [disabled]="form.invalid || (loading$ | async)"
                      label="Pesquisar"
                      type="submit"
                      title="Pesquisar"
                      aria-label="left">
                      <loading-icon
                        class="align-content-center"
                        [btnLabel]="'Pesquisar'"
                        [loading]="loading$ | async"
                      ></loading-icon>
                    </button>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <app-total-table  (onChange)="changeItensPerPage($event)" [totalRegistros]="this.totalRegistros"></app-total-table>
      <table
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
        <tr>
          <th>Data</th>
          <th>Usuário</th>
          <th>Ação</th>
          <th>Tipo</th>
          <th>Descrição</th>
          <th class="text-center">Ações</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let r of feitoConferidos">
          <tr class="element-row">
            <td>{{ r.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            <td>{{ r.username }}</td>
            <td>{{ getDescription(r.action) }}</td>
            <td>{{ r.entryType }}</td>
            <td>{{ r.description }}</td>
            <td class="pt-1 pb-1">
              <app-feito-conferido-acoes
                [feitoConferido]="r"
                (exibir)="openEditDialog($event)"
                (autorizado)="autorizar($event)"
                (rejeitado)="rejeitar($event)"
                (error)="notificarErro($event)">
              </app-feito-conferido-acoes>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <maps-pagination
      [pageNumber]="page$"
      [items]="paginationTotalPage"
      *ngIf="paginationTotalPage && paginationTotalPage > 0"
      (pageSend)="receiverPage($event)"
    ></maps-pagination>
  </div>
</div>
